import React, { createContext, useState, useEffect } from "react";
import Cookies from "universal-cookie";
import axios from "axios";
import { Store } from "react-notifications-component";

import homepicture from "../components/pages/Images/homepicture.png";
import homepicture2 from "../components/pages/Images/homepicture2.png";
import supplypic from "../components/pages/Images/supplypic.png";
import supplypic2 from "../components/pages/Images/supplypic2.png";
import supplypicture from "../components/pages/Images/supplypicture.png";
import supplypicture2 from "../components/pages/Images/supplypicture2.png";
import changepricepicture from "../components/pages/Images/changepricepicture.png";
import changepricepicture2 from "../components/pages/Images/changepricepicture2.png";
import salespicture from "../components/pages/Images/salespicture.png";
import salespicture2 from "../components/pages/Images/salespicture2.png";
import accountpicture from "../components/pages/Images/accountpicture.png";
import accountpicture2 from "../components/pages/Images/accountpicture2.png";
import myreportpicture from "../components/pages/Images/myreportpicture.png";
import myreportpicture2 from "../components/pages/Images/myreportpicture2.png";
import passwordpicture from "../components/pages/Images/passwordpicture.png";
import passwordpicture2 from "../components/pages/Images/passwordpicture2.png";
import inventorypicture from "../components/pages/Images/inventorypicture.png";
import inventorypicture2 from "../components/pages/Images/inventorypicture2.png";
import adminpicture from "../components/pages/Images/adminpicture.png";
import adminpicture2 from "../components/pages/Images/adminpicture2.png";
import newuserpicture from "../components/pages/Images/newuserpicture.png";
import newuserpicture2 from "../components/pages/Images/newuserpicture2.png";
import viewuserpicture from "../components/pages/Images/viewuserpicture.png";
import viewuserpicture2 from "../components/pages/Images/viewuserpicture2.png";
import viewdebtpicture from "../components/pages/Images/viewdebtpicture.png";
import viewdebtpicture2 from "../components/pages/Images/viewdebtpicture2.png";
import historypicture from "../components/pages/Images/historypicture.png";
import historypicture2 from "../components/pages/Images/historypicture2.png";
import backuppicture from "../components/pages/Images/backuppicture.png";
import backuppicture2 from "../components/pages/Images/backuppicture2.png";
import salesreportpicture from "../components/pages/Images/salesreportpicture.png";
import salesreportpicture2 from "../components/pages/Images/salesreportpicture2.png";
import logoutpicture from "../components/pages/Images/logoutpicture.png";
import logoutpicture2 from "../components/pages/Images/logoutpicture2.png";

const PermissionContext = createContext({
  logged: false,
  Expired: false,
  Username: "",
  NS: "",
  MR: "",
  SI: "",
  CP: "",
  ASt: "",
  VS: "",
  CPw: "",
  SP: "",
  SR: "",
  GS: "",
  IV: "",
  CR: "",
  VD: "",
  CF: "",
  GH: "",
  US: "",
  Menus: [],
  setExpired: () => {},
  GetCookiesValue: () => {},
  connectAxios: () => {},
  displayAlert: () => {},
  ReloadReport: false,
  DatesSelected: "",
  ReceivedCash: 0,
  ReceivedPOS: 0,
  ReceivedTransfer: 0,
  ReceivedCredit: 0,
  SpentCash: 0,
  SpentPOS: 0,
  SpentTransfer: 0,
  UpdReceivedCash: () => {},
  UpdReceivedPOS: () => {},
  UpdReceivedCredit: () => {},
  UpdReceivedTransfer: () => {},
  UpdSpentCash: () => {},
  UpdSpentPOS: () => {},
  UpdSpentTransfer: () => {},
  UpdDatesSelected: () => {},
});

export const PermissionContextProvider = (props) => {
  const cookies = new Cookies();
  const [AxiosError, setAxiosError] = useState("");
  const [Userlogged, setUserlogged] = useState(false);
  const [Userlog, setUserlog] = useState(false);
  const [willExpire, setwillExpire] = useState(false);
  const [MyUsername, setMyUsername] = useState("");
  const [MyUserID, setMyUserID] = useState("");
  const [mypath, setMyPath] = useState("");
  const [NS, setNS] = useState(0);
  const [MR, setMR] = useState(0);
  const [SI, setSI] = useState(0);
  const [CP, setCP] = useState(0);
  const [ASt, setASt] = useState(0);
  const [VS, setVS] = useState(0);
  const [CPw, setCPw] = useState(0);
  const [SP, setSP] = useState(0);
  const [SR, setSR] = useState(0);
  const [GS, setGS] = useState(0);
  const [IV, setIV] = useState(0);
  const [CR, setCR] = useState(0);
  const [VD, setVD] = useState(0);
  const [CF, setCF] = useState(0);
  const [GH, setGH] = useState(0);
  const [US, setUS] = useState(0);
  const [MyMenus, setMyMenus] = useState([]);
  const [RelRep, setRelRep] = useState(false);
  const [RCASH, setRCASH] = useState(0);
  const [RPOS, setRPOS] = useState(0);
  const [RTRAN, setRTRAN] = useState(0);
  const [RCR, setRCR] = useState(0);
  const [SCASH, setSCASH] = useState(0);
  const [STRAN, setSTRAN] = useState(0);
  const [SPOS, setSPOS] = useState(0);
  const [DSel, setDSel] = useState("");
  const [ThePath, setThePath] = useState("");
  var CryptoJS = require("crypto-js");
  let ConnectionCount = 0;

  useEffect(() => {
    let p1 = cookies.get("logged");
    let p2 = p1 ? p1 : false;
    let U1 = cookies.get("this_staff");
    let U2 = U1 ? U1 : "";
    let UN = cookies.get("userid");
    let USN = UN ? UN : "";
    let NS1 = cookies.get("NS");
    let MR1 = cookies.get("MR");
    let SI1 = cookies.get("SI");
    let CP1 = cookies.get("CP");
    let ASt1 = cookies.get("ASt");
    let VS1 = cookies.get("VS");
    let CPw1 = cookies.get("CPw");
    let SP1 = cookies.get("SP");
    let SR1 = cookies.get("SR");
    let GS1 = cookies.get("GS");
    let IV1 = cookies.get("IV");
    let CR1 = cookies.get("CR");
    let VD1 = cookies.get("VD");
    let CF1 = cookies.get("CF");
    let GH1 = cookies.get("GH");
    let US1 = cookies.get("US");

    setNS(NS1);
    setMR(MR1);
    setSI(SI1);
    setCP(CP1);
    setASt(ASt1);
    setVS(VS1);
    setCPw(CPw1);
    setSP(SP1);
    setSR(SR1);
    setGS(GS1);
    setIV(IV1);
    setCR(CR1);
    setVD(VD1);
    setCF(CF1);
    setGH(GH1);
    setUS(US1);
    setMyUsername(U2);
    setMyUserID(USN);
    setUserlogged(p2);
  }, [Userlog]);

  useEffect(() => {
    let eXP = cookies.get("ExpiredItems");

    let Expir = eXP === "Yes" ? true : false;
    setwillExpire(Expir);
  }, []);

  useEffect(() => {
    const decryption = (Scramb) => {
      let Permission = false;
      if (Userlogged) {
        // Scramb = "U2FsdGVkX1/WscdZ+9IV7bHNnXe+9Ptb9Fcv1faThVI=";
        let Scrambled = Scramb.replace(/\s/g, "");
        var bytes = CryptoJS.AES.decrypt(Scrambled, "143tonybridget");
        let Allowance = bytes.toString(CryptoJS.enc.Utf8);
        Permission = parseInt(Allowance) === 1 ? true : false;
      }
      return Permission;
    };
    const location = "unaccessible";
    let TheMenus = [
      {
        title: "Home",
        path: mypath + "/",
        picture: homepicture,
        hoverpicture: homepicture2,
        HasMouseEntered: false,
      },

      {
        title: "Supply",
        dropitdown: false,
        picture: supplypic,
        hoverpicture: supplypic2,
        HasMouseEntered: false,
        submenu: [
          {
            title: "Supply-In",
            path: decryption(SI) ? mypath + "/supplyin" : { location },
            picture: supplypicture,
            hoverpicture: supplypicture2,
            HasMouseEntered: false,
          },
          {
            title: "Change Price",
            path: decryption(CP) ? mypath + "/changeprice" : { location },
            picture: changepricepicture,
            hoverpicture: changepricepicture2,
            HasMouseEntered: false,
          },
        ],
      },
      {
        title: "Sales",
        path: decryption(NS) ? mypath + "/sales" : { location },
        picture: salespicture,
        hoverpicture: salespicture2,
        HasMouseEntered: false,
      },
      {
        title: "My Account",
        dropitdown: false,
        picture: accountpicture,
        hoverpicture: accountpicture2,
        HasMouseEntered: false,
        submenu: [
          {
            title: "My Report",
            path: decryption(MR) ? mypath + "/myreport" : { location },
            picture: myreportpicture,
            hoverpicture: myreportpicture2,
            HasMouseEntered: false,
          },
          {
            title: "Change My Password",
            path: decryption(CPw) ? mypath + "/changepassword" : { location },
            picture: passwordpicture,
            hoverpicture: passwordpicture2,
            HasMouseEntered: false,
          },
        ],
      },
      {
        title: "Inventory",
        path: decryption(IV) ? mypath + "/inventory" : { location },
        picture: inventorypicture,
        hoverpicture: inventorypicture2,
        HasMouseEntered: false,
      },

      {
        title: "Admin",
        dropitdown: false,
        picture: adminpicture,
        hoverpicture: adminpicture2,
        HasMouseEntered: false,
        submenu: [
          {
            title: "Add New Staff",
            path: decryption(ASt) ? mypath + "/addnewuser" : { location },
            picture: newuserpicture,
            hoverpicture: newuserpicture2,
            HasMouseEntered: false,
          },
          {
            title: "View Staff",
            path: decryption(VS) ? mypath + "/viewusers" : { location },
            picture: viewuserpicture,
            hoverpicture: viewuserpicture2,
            HasMouseEntered: false,
          },
          {
            title: "Get Sales Report",
            path: decryption(SP) ? mypath + "/getreport" : { location },
            picture: salesreportpicture,
            hoverpicture: salesreportpicture2,
            HasMouseEntered: false,
          },
          {
            title: "Get Supply Report",
            path: decryption(SR) ? mypath + "/getsupplyreport" : { location },
            picture: supplypicture,
            hoverpicture: supplypicture2,
            HasMouseEntered: false,
          },
          {
            title: "Customers Records",
            path: decryption(CR) ? mypath + "/customersreports" : { location },
            picture: inventorypicture,
            hoverpicture: inventorypicture2,
            HasMouseEntered: false,
          },
          {
            title: "View All Debts",
            path: decryption(VD) ? mypath + "/viewdebts" : { location },
            picture: viewdebtpicture,
            hoverpicture: viewdebtpicture2,
            HasMouseEntered: false,
          },
          {
            title: "Cash Flow",
            path: decryption(VD) ? mypath + "/cashflow" : { location },
            picture: viewdebtpicture,
            hoverpicture: viewdebtpicture2,
            HasMouseEntered: false,
          },
          {
            title: "Get Item History",
            path: decryption(GH) ? mypath + "/gethistory" : { location },
            picture: historypicture,
            hoverpicture: historypicture2,
            HasMouseEntered: false,
          },
          {
            title: "Update Online Server",
            path: decryption(US) ? mypath + "/updateonline" : { location },
            picture: historypicture,
            hoverpicture: historypicture2,
            HasMouseEntered: false,
          },
          {
            title: "Back - up",
            path: mypath + "/backup",
            picture: backuppicture,
            hoverpicture: backuppicture2,
            HasMouseEntered: false,
          },
        ],
      },
      {
        title: "Log Out",
        path: "/",
        picture: logoutpicture,
        hoverpicture: logoutpicture2,
        HasMouseEntered: false,
      },
    ];
    // console.log(TheMenus);
    setMyMenus(TheMenus);
  }, [Userlogged]);

  const GetTheCookiesValue = () => {
    setUserlog(!Userlog);
  };

  const displayAlert = (mytitle, mymsg, mytype) => {
    Store.addNotification({
      title: mytitle,
      message: mymsg,
      type: mytype,
      insert: "top",
      container: "top-center",
      animationIn: ["animate__animated", "animate__BounceOut"],
      animationOut: ["animate__animated", "animate__fadeOut"],
      dismiss: {
        duration: 7000,
        onScreen: true,
        showIcon: true,
      },
    });
  };

  const connectAxios = async (url, dt) => {
    let myresponse;

    await axios({
      method: "post",
      url: "applauseinfotech/phpfiles/" + url,
      headers: {
        "Content-type": "multipart/form-data",
      },
      data: { dt },
    })
      .then((dat) => {
        ConnectionCount = 0;
        var response = dat.data;
        myresponse = response;
        return myresponse;
      })
      .catch((error) => {
        ConnectionCount++;
        if (ConnectionCount < 5) {
          connectAxios(url, dt);
        } else {
          displayAlert(
            "ERROR IN CONNECTION",
            "There is an error in connecting to the server, Please check your network or call on network administrator",
            "danger",
          );
        }

        setAxiosError(error.message);
      });
    return myresponse;
  };

  const context = {
    Menus: [...MyMenus],
    logged: Userlogged,
    Username: MyUsername,
    Expired: willExpire,
    NS: NS,
    MR: MR,
    SI: SI,
    CP: CP,
    ASt: ASt,
    VS: VS,
    CPw: CPw,
    SP: SP,
    SR: SR,
    GS: GS,
    IV: IV,
    CR: CR,
    VD: VD,
    CF: CF,
    GH: GH,
    US: US,
    GetCookiesValue: GetTheCookiesValue,
    connectAxios: connectAxios,
    displayAlert: displayAlert,
    UserId: MyUserID,
    ReloadReport: RelRep,
    setReloadReport: setRelRep,
    setExpired: setwillExpire,
    ReceivedCash: RCASH,
    ReceivedTransfer: RTRAN,
    ReceivedPOS: RPOS,
    ReceivedCredit: RCR,
    ThePath: mypath,
    SpentCash: SCASH,
    SpentTransfer: STRAN,
    SpentPOS: SPOS,

    DatesSelected: DSel,
    UpdDatesSelected: setDSel,
    UpdReceivedCash: setRCASH,
    UpdReceivedPOS: setRPOS,
    UpdReceivedTransfer: setRTRAN,
    UpdReceivedCredit: setRCR,
    UpdSpentCash: setSCASH,
    UpdSpentPOS: setSPOS,
    UpdSpentTransfer: setSTRAN,
  };

  return (
    <PermissionContext.Provider value={context}>
      {props.children}
    </PermissionContext.Provider>
  );
};

export default PermissionContext;
